import { IconCopy } from '@tabler/icons-react';
import React from 'react';
import {
  BasicActionIcon,
  IBasicActionIconProps,
} from 'src/design/atoms/BasicActionIcon';

export type ICopyActionIconProps = Omit<IBasicActionIconProps, 'children'>;

const DefaultProps: Partial<ICopyActionIconProps> = {
  color: 'blue',
  label: 'Copy',
};

/** @registry Blue "copy" action icon (two-sheets symbol) built on BasicActionIcon, labelled "Copy" by default. */
export const CopyActionIcon = React.forwardRef<
  HTMLButtonElement,
  ICopyActionIconProps
>((props, ref) => {
  return (
    <BasicActionIcon {...DefaultProps} {...props} ref={ref}>
      <IconCopy size={20} />
    </BasicActionIcon>
  );
});
CopyActionIcon.displayName = 'CopyActionIcon';
